function handle(msg) {
  if (msg.includes("insufficient funds")) {
    alert("You don't have sufficient Matic in your wallet.");
    return;
  }

  if (msg.includes("Domain is not available.")) {
    alert("This domain is already booked. Try again with a different domain.");
    return;
  }

  if (msg.includes("You are not allowed to do this.")) {
    alert("Error while signing signature. Try Again.");
    return;
  }
  if (msg.includes("Failed to fetch balance")) {
    alert("Failed to fetch balance. Please try again.");
    return;
  }
  if (msg.includes("insufficient balance for transfer")) {
    alert("You don't have sufficient Matic in your wallet.");
    return;
  }
  // Default alert for any other message
  alert(msg);
}

function web3ErrorHandler(error) {
  // Check if the error has a nested message
  if (error.data?.message) {
    handle(error.data.message.toString());
  } else {
    handle(error.message.toString());
  }
}

export default web3ErrorHandler;
